// src/store/modules/pickup/actions.js
import util from '../../../util'
import MediaPickupApi from '../../../api/modules/PickupApi'

const savePickup = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post(`pickups/${payload.idClient}/save`, payload.pickup, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al registrar la solicitud de pedido.')
      reject(error)
    });
  })

};

const loadPickupList = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`pickups/${payload.idClient}/${payload.type}`, {headers}).then((response) => {
      commit('setPickupList', response.data)
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Error al cargar las solicitudes de recojo')
      reject(error)
    });
  })

};

const cancelPickup = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.delete(`pickups/${payload.idClient}/${payload.idPickup}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cancelar el recojo.')
      reject(error)
    });
  })

};

/**
 * Búsqueda paginada y filtrada de recojos de medios
 */
const searchPickups = ({commit}, payload) => {
  return MediaPickupApi.searchPickups(payload.context, payload.idClient, payload)
}

const setPickupStorageMode = ({commit}, mode) => {
  commit('setPickupStorageMode', mode);
};

export default {
  savePickup,
  loadPickupList,
  cancelPickup,
  searchPickups,
  setPickupStorageMode,
};



// WEBPACK FOOTER //
// ./src/store/modules/pickup/actions.js